/* global BackboneEx */
import React from 'react';
import ReactDOM from 'react-dom';
import { Reconnect } from 'federation/Reconnect';

App.Views.BeConcept = BackboneEx.View.Main.extend({
  initialize() {},

  render() {
    App.headerView.setModule('masterclass');
    const node = this.$('#masterclass-section').get(0);
    if (node) {
      ReactDOM.render(<Reconnect name="BeConcept" />, node);
    }
  },
});
